<template>
  <div class="admin-container">
    <div class="action-header">
      <el-button type="primary" @click="handleAdd">添加管理员</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="loginName">
        <template slot="header" slot-scope="scope">
          <div>用户账号</div>
          <el-input
            v-model="search.loginName"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="trueName">
        <template slot="header" slot-scope="scope">
          <div>姓名</div>
          <el-input
            v-model="search.trueName"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile">
        <template slot="header" slot-scope="scope">
          <div class="title">手机号</div>
          <el-input
            v-model="search.mobile"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="email">
        <template slot="header" slot-scope="scope">
          <div>邮箱</div>
          <el-input
            v-model="search.email"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatRole"
        prop="roleId">
        <template slot="header" slot-scope="scope">
          <div>角色</div>
          <el-select v-model="search.roleId" filterable  @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"/>
    </div>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="modalTitle" center>
      <el-form ref="dialogForm" :model="dialogForm" :rules="rules" class="modal" label-width="100px">
        <el-form-item label="上传头像">
          <el-upload
            :accept="accept"
            :action="qiniuUp"
            :data="dataObj"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeAvatarUpload"
            class="avatar-uploader">
            <img v-if="dialogForm.profile" :src="dialogForm.profile | ImageFormats" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item label="登录账号" prop="loginName">
          <el-input v-model="dialogForm.loginName" :disabled="isEditMode"/>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="dialogForm.password" :type="passwordType" />
          <!--<el-button type="text" @mouseup="passwordType = 'password'" @click="togglePassType">{{passwordType == 'password'?'查看密码明文':'查看密码'}}</el-button>-->
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="dialogForm.trueName" />
        </el-form-item>
        <el-form-item label="选择角色">
          <el-select v-model="dialogForm.roleId" filterable placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.title"
              :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="dialogForm.mobile" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="dialogForm.email" />
        </el-form-item>
        <el-form-item label="微信号">
          <el-input v-model="dialogForm.wx" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="dialogForm.status">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="-1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>
import find from 'lodash/find'
import { getQiniuUploadToken } from '@/api/site'
import { getAdminUserList, addAdminUser, getAdminUser, deleteAdminUser, updateAdminUser, getRoleList } from '@/api/site'
import { varConfig, ImageFormat, showMessage, ConstConfig } from '@/utils'

const defaultForm = {
  profile: '',
  loginName: '',
  trueName: '',
  password: '123456',
  roleId: '',
  email: '',
  mobile: '',
  wx: '',
  status: 0
}

export default {
  name: 'AdminList',
  data() {
    return {
      roleList: [],
      search: {},
      list: [],
      dialogForm: {},
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      isEditMode: false,
      modalTitle: '',
      passwordType: 'password',
      dialogVisible: false,
      formLabelWidth: '100px',
      qiniuUp: varConfig.qiniuUp,
      dataObj: { token: '' },
      accept: ConstConfig.accept,
      rules: {
        loginName: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ]
//        password: [
//          { required: true, message: '请输入登录密码', trigger: 'blur' },
//          { min: 6, max: 200, message: '长度在 6 到 20 个字符', trigger: 'blur' }
//        ]
      }
    }
  },
  created() {
    this.getList()
    this.getRoleList()
    this.getQiniuToken()
  },
  computed: {},
  watch: {},
  methods: {
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加管理员信息'
      this.dialogForm = Object.assign({}, defaultForm)
    },
    handleEdit(index, row) {
      this.getAdminUserById(this.list[index].id)
      this.dialogVisible = true
      this.isEditMode = true
      this.modalTitle = '编辑管理员信息'
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该管理员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteAdminUser(this.list[index].id)
      }).catch(() => {
      })
    },
    formatRole: function(row, column) {
      const roleId = row[column.property]
      const role = find(this.roleList, function(item) {
        return item.id === roleId
      })
      return role && role.title
    },
    // image upload
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    handleUploadSuccess(res, file) {
//      console.log(res, file)
      this.dialogForm.profile = res.hash
//      console.log(this.dialogForm.profile)
    },
    handleUploadError(res, file) {
      showMessage('error', '上传图片失败')
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
      }).catch(err => {
        showMessage(err, 'error', '七牛Token获取失败')
      })
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.isEditMode) {
            this.updateAdminUser()
          } else {
            this.addAdminUser()
          }
        } else {
          return false
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getAdminUserList(this.listQuery).then(response => {
        const data = response.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },
    getAdminUserById(userId) {
      getAdminUser(userId).then(response => {
        const data = response.data
        this.dialogForm = data.admin
        this.dialogForm.loginName = data.admin.loginId
      })
    },
    addAdminUser() {
      addAdminUser(this.dialogForm).then(response => {
        const data = response.data
        if(data && data.admin) {
          this.dialogVisible = false
          showMessage('success', '创建成功')
          this.getList()
        }
      })
    },
    updateAdminUser() {
      const data = {
        userId: this.dialogForm.id,
        profile: this.dialogForm.profile,
        trueName: this.dialogForm.trueName,
        password: this.dialogForm.password,
        roleId: this.dialogForm.roleId,
        email: this.dialogForm.email,
        mobile: this.dialogForm.mobile,
        wx: this.dialogForm.wx,
        status: this.dialogForm.status
      }
      updateAdminUser(data).then(response => {
        const data = response.data
        if(data) {
          this.dialogVisible = false
          showMessage('success', '更新成功')
          this.getList()
        }
      })
    },
    deleteAdminUser(userId) {
      deleteAdminUser(userId).then(response => {
        const data = response.data
        if(data) {
          showMessage('success', '删除成功')
          this.getList()
        }
      })
    },
    getRoleList() {
      getRoleList({status: 0}).then(response => {
        const data = response.data
        this.roleList = data.list
      })
    },
    togglePassType() {
      if(this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 156)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.admin-container {
  margin: 30px 15px;
  .action-header {
    padding: 0 10px 10px 10px;
  }
  .el-table {
    th {
      div {
        line-height: 20px;
      }
      .el-select {
        padding-left: 0;
        padding-right: 0;
        .el-input {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }

  .table-footer {
    text-align: center;
    margin-top: 30px;
  }

  /* avatar upload start */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 20px;
    color: #8c939d;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }
  .avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
  /* avatar upload end */

  /* dialog modal start */
  .el-dialog {
    width: 540px;
    .el-form-item {
      .el-input {
        width: 300px;
      }
    }
  }
  /* dialog modal end*/
}
</style>
